export const ccip = {
  avalancheFuji: {
    chainId: 43113,
    chainSelector: "14767482510784806043",
    router: "0xF694E193200268f9a4868e4Aa017A0118C9a8177",
    rmnProxy: "0xAc8CFc3762a979628334a0E4C1026244498E821b",
    tokenAdminRegistry: "0xA92053a4a3922084d992fD2835bdBa4caC6877e6",
    registryModuleOwnerCustom: "0x97300785aF1edE1343DB6d90706A35CF14aA3d81",
    link: "0x0b9d5D9136855f6FEc3c0993feE6E9CE8a297846",
    confirmations: 2,
    nativeCurrencySymbol: "AVAX",
  },
  arbitrumSepolia: {
    chainId: 421614,
    chainSelector: "3478487238524512106",
    router: "0x2a9C5afB0d0e4BAb2BCdaE109EC4b0c4Be15a165",
    rmnProxy: "0x9527E2d01A3064ef6b50c1Da1C0cC523803BCFF2",
    tokenAdminRegistry: "0x8126bE56454B628a88C17849B9ED99dd5a11Bd2f",
    registryModuleOwnerCustom: "0xE625f0b8b0Ac86946035a7729Aba124c8A64cf69",
    link: "0xb1D4538B4571d411F07960EF2838Ce337FE1E80E",
    confirmations: 2,
    nativeCurrencySymbol: "ETH",
  },
  ethereumSepolia: {
    chainId: 11155111,
    chainSelector: "16015286601757825753",
    router: "0x0BF3dE8c5D3e8A2B34D2BEeB17ABfCeBaf363A59",
    rmnProxy: "0xba3f6251de62dED61Ff98590cB2fDf6871FbB991",
    tokenAdminRegistry: "0x95F29FEE11c5C55d26cCcf1DB6772DE953B37B82",
    registryModuleOwnerCustom: "0x62e731218d0D47305aba2BE3751E7EE9E5520790",
    link: "0x779877A7B0D9E8603169DdbD7836e478b4624789",
    confirmations: 2,
    nativeCurrencySymbol: "ETH",
  },
  baseSepolia: {
    chainId: 84532,
    chainSelector: "10344971235874465080",
    router: "0xD3b06cEbF099CE7DA4AcCf578aaebFDBd6e88a93",
    rmnProxy: "0x99360767a4705f68CcCb9533195B761648d6d807",
    tokenAdminRegistry: "0x736D0bBb318c1B27Ff686cd19804094E66250e17",
    registryModuleOwnerCustom: "0x8A55C61227f26a3e2f217842eCF20b52007bAaBe",
    link: "0xE4aB69C077896252FAFBD49EFD26B5D171A32410",
    confirmations: 2,
    nativeCurrencySymbol: "ETH",
  },
  shibuya: {
    chainId: 81,
    chainSelector: "6955638871347136141",
    router: "0x22aE550d87eBf775E0c1fDc8881121c8A51F5903",
    rmnProxy: "0xc96ac0533F240ad52694391583267ACAbc479C07",
    tokenAdminRegistry: "0x54eBB8F7E81305E1bBdDD03860A9a5D41312bB35",
    registryModuleOwnerCustom: "0xc5F62dF12F09dd4a0Ff3Ec85D54a28Be87759c9d",
    link: "0xe74037112db8807B3B4B3895F5790e5bc1866a29",
    confirmations: 3,
    nativeCurrencySymbol: "SBY",
  },
  minato: {
    chainId: 1337,
    chainSelector: "686603546605904534",
    router: "0x443a1bce545d56E2c3f20ED32eA588395FFce0f4",
    rmnProxy: "0x6172F4f60eEE3876cF83318DEe4477BfAf15Ffd3",
    tokenAdminRegistry: "0xD2334a6f4f79CE462193EAcB89eB2c29Ae552750",
    registryModuleOwnerCustom: "0xe06fE3AEfef3a27b8BF0edd5ae834B006EdE3aa1",
    link: "0x7ea13478Ea3961A0e8b538cb05a9DF0477c79Cd2",
    confirmations: 3,
    nativeCurrencySymbol: "ETH",
  },
  testbnb: {
    chainId: 97,
    chainSelector: "13264668187771770619",
    router: "0xE1053aE1857476f36A3C62580FF9b016E8EE8F6f",
    rmnProxy: "0xA8C0c11bf64AF62CDCA6f93D3769B88BdD7cb93D",
    tokenAdminRegistry: "0xF8f2A4466039Ac8adf9944fD67DBb3bb13888f2B",
    registryModuleOwnerCustom: "0x763685240370758c5ac6C5F7c22AB36684c0570E",
    link: "0x84b9B910527Ad5C03A9Ca831909E21e236EA7b06",
    confirmations: 3,
    nativeCurrencySymbol: "BNB",
  },
  testpolygon: {
    chainId: 80002,
    chainSelector: "16281711391670634445",
    router: "0x9C32fCB86BF0f4a1A8921a9Fe46de3198bb884B2",
    rmnProxy: "0x7c1e545A40750Ee8761282382D51E017BAC68CBB",
    tokenAdminRegistry: "0x1e73f6842d7afDD78957ac143d1f315404Dd9e5B",
    registryModuleOwnerCustom: "0x84ad5890A63957C960e0F19b0448A038a574936B",
    link: "0x0Fd9e8d3aF1aaee056EB9e802c3A762a667b1904",
    confirmations: 3,
    nativeCurrencySymbol: "POL",
  },
  astar: {
    chainId: 592,
    ChainSelector: "6422105447186081193",
    Router: "0x8D5c5CB8ec58285B424C93436189fB865e437feF",
    rmnProxy: "0x7317D216F3DCDa40144a54eC9bA09829a423cb35",
    tokenAdminRegistry: "0xB98eEd70e3cE8E342B0f770589769E3A6bc20A09",
    registryModuleOwnerCustom: "0x9c54A7E067E5bdB8e1A44eA7a657053780d35d58",
    LINK: "0x31EFB841d5e0b4082F7E1267dab8De1b853f2A9d",
    confirmations: 3,
    nativeCurrencySymbol: "ASTR",
  },
  soneium: {
    chainId: 1868,
    ChainSelector: "12505351618335765396",
    Router: "0x8C8B88d827Fe14Df2bc6392947d513C86afD6977",
    rmnProxy: "0x3117f515D763652A32d3D6D447171ea7c9d57218",
    tokenAdminRegistry: "0x5ba21F6824400B91F232952CA6d7c8875C1755a4",
    registryModuleOwnerCustom: "0x1d0B6B3ef94dD6A68b7E16bd8B01fca9EA8e3d6E",
    LINK: "0x32D8F819C8080ae44375F8d383Ffd39FC642f3Ec",
    confirmations: 3,
    nativeCurrencySymbol: "ETH",
  },
};
